<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-button type="primary" @click="handelResultSet" plain
          >基本结果设置
          </el-button
          >
          <el-button @click="goBack" type="danger" plain
          >返回题目
          </el-button
          >
        </div>
      </div>
    </div>
    <div class="topic-outer" style="padding-top:20px">
      <el-tabs v-model="activeNames" @tab-click="handleTabClick">
        <el-tab-pane label="分数区间设置" name="first"></el-tab-pane>
        <el-tab-pane label="画像结果设置" name="second"></el-tab-pane>
      </el-tabs>
      <div v-if="activeNames=='first'">
        <el-tabs
            tab-position="left"
            v-model="activeName"
            @tab-click="handleClick"
        >
          <el-tab-pane
              v-if="index!=0"
              v-for="(item,index) in getWDData"
              :key="index"
              :label="item.name"
              :name="item.code"
          >
          </el-tab-pane>
          <div style="margin-left: 20px">
            <div class="public-dialog-form">
              <div v-for="(item,index) in qjList" :key="index" style="margin-bottom: 20px">
                <div class="item_contents">
                  <div>
                    <div class="input_item">
                      <div class="name">分数区间：</div>
                      <div>
                        <el-input style="width: 260px" v-model="item.minScore" type="number"
                                  placeholder="请输入最小分值（大于等于）"></el-input>
                        -
                        <el-input v-model="item.maxScore" style="width: 260px" type="number"
                                  placeholder="请输入最大分值（小于等于）"></el-input>
                      </div>
                    </div>
                    <div class="input_item">
                      <div class="name">区间名称：</div>
                      <div>
                        <el-input v-model="item.title" style="width: 260px" placeholder="请输入名称"></el-input>
                      </div>
                    </div>
                  </div>
                  <div v-if="qjList.length>1" @click="removeQj(index)" class="remove_icon"><i class="el-icon-delete"
                                                                                              style="color: #c7302f;font-size: 18px"></i>
                  </div>
                </div>
                <div>
                  <el-button @click="handQjEdit(index,item)" type="primary">保存设置</el-button>
                </div>
              </div>
            </div>
            <div>
              <el-button type="primary" @click="addQj">添加分数区间</el-button>
            </div>
          </div>
        </el-tabs>
      </div>
      <div v-if="activeNames=='second' && initJZData && initJZData.length">
        <el-tabs
            tab-position="left"
            v-model="activeNameT"
            @tab-click="handTabLimt"
        >
          <el-tab-pane
              v-for="item in initJZData"
              :key="item.examResultId"
              :label="item.name"
              :name="item.examResultId.toString()"
          >
          </el-tab-pane>
          <div style="margin-left: 20px">
            <div class="public-dialog-form">
              <el-form
                  ref="ruleForm"
                  :rules="rules"
                  :model="params"
                  label-width="85px"
              >
                <el-form-item label="画像名称" prop="title">
                  <el-input v-model="params.title" style="width: 260px" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="画像说明" prop="content">
                  <el-input
                      style="width: 420px"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 4 }"
                      placeholder="请填写主题"
                      v-model="params.content"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="public-dialog-footer">
                      <el-button size="medium" @click="handleEdit('reset')"
                      >重 置</el-button
                      >
                      <el-button
                          size="medium"
                          type="primary"
                          @click="handleEdit('add')"
                      >提 交</el-button
                      >
                    </span>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        title: [
          {
            required: true,
            message: "请填写标题",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写入内容",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},
      activeNames: 'first',
      activeNameT: '',
      getWDData: [],
      qjList: [
        {
          min: 0,
          max: 0,
          name: ''
        }
      ]
    };
  },
  created() {
    this.getAppraisalData();
    this.getWDList();
    // this.initJZ()
  },
  methods: {
    /**
     * 跳转结果设置
     */
    handelResultSet() {
      this.$router.push({
        name: "RGTP_SET",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
    handQjEdit(index, item) {
      if (!item.minScore) {
        this.$message.error('最小分数不能为空')
        return
      }
      if (!item.maxScore) {
        this.$message.error('最大分数不能为空')
        return
      }
      if (!item.title) {
        this.$message.error('名称不能为空')
        return
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (item.examResultId) {
          let obj = {
            resultType: 'rgtp',
            examId: this.$route.query.examId,
            examDimensionCode: this.activeName,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            examResultId: item.examResultId
          }
          const {data: resData} = await this.$put(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        } else {
          let obj = {
            resultType: 'rgtp',
            examId: this.$route.query.examId,
            examDimensionCode: this.activeName,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            examResultId: item.examResultId
          }
          const {data: resData} = await this.$post(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        }
      })
    },
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data)
        if (resData.data) {
          this.getWDData = resData.data;
          this.activeName = resData.data[1].code
          this.initQjJZ()
        } else {
          this.getWDData = []
        }
    },

    handleTabClick() {
      if (this.activeNames == 'first') {
        this.getWDList();
      } else {
        this.initJZ()
      }
    },

    removeQj(e, item) {
      if (item.examResultId) {
        this.$confirm("确认删除数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$delete(
              "exam/result/info/" + item.examResultId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
          this.qjList.splice(e, 1)
        })
      } else {
        this.qjList.splice(e, 1)
      }
    },

    addQj() {
      let obj = {
        min: 0,
        max: 0,
        name: ''
      }
      this.qjList.push(obj)
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;

      const {data: resData} = await this.$post(
          `exam/result/init/datum/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.jzIsShow = false;
        this.jzIsHiden = true;
        resData.data.map(item => {
          item.examResultContent = item.name + '\n' + item.code
        })
        this.initJZData = resData.data;
        let id = resData.data[0].examResultId;
        this.activeNameT = id.toString();
        this.params.examResultId = id;
        this.resultDetails(id);
      } else {
        this.initJZData = []
      }

    },

    handleEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
          })
        });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.params = {}
          this.$message.success("重置成功!");
        })
      }
    },
    async initQjJZ() {
      this.loading = true;
      const {data: resData} = await this.$get(
          '/exam/result/list?examId=' + this.$route.query.examId + '&examDimensionCode=' + this.activeName + '&resultType=rgtp'
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.qjList = resData.data
      } else {
        this.qjList = [
          {
            minScore: 0,
            maxScore: 0,
            title: '',
            descr: ''
          }
        ]
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(
          `exam/result/info/${examResultId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );

      if (resData.result != 200) return;
      this.params = resData.data;
    },

    handleClick() {
      this.initQjJZ()
    },

    handTabLimt(tab, event) {
      this.$refs.ruleForm.resetFields();
      this.params.examResultId = parseInt(tab.name);
      this.resultDetails(tab.name);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}


</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  line-height: 20px;
  height: 26px !important;
}
</style>